import React from 'react';
import { Typography, Container } from '@mui/material';
import ToolHeader from './ToolHeader';
export default function TermsConditions() {
    return (


        <Container
            maxWidth="lg"
            sx={{
                pt: 20,
                pb: 4
            }}
        >
            <ToolHeader title="Privacy Policy" />
            <Typography variant="h6" component="h1" gutterBottom>
                Terms and Conditions
            </Typography>
            <Typography variant="body1" gutterBottom>
                Last updated: 12-Jan-2025
            </Typography>

            <Typography variant="body1" gutterBottom>
                PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING THIS APPLICATION.
                Welcome to TextSimpler ("we," "our," or "us"). These Terms and Conditions ("Terms") govern your use of our website located at https://textsimpler.com (the "Website"). By accessing or using the Website, you agree to comply with these Terms. If you do not agree, please do not use the Website.
                This is a legally binding agreement between you and TextSimpler. These Terms of Service govern the use of the applications or websites operated by or on behalf of [Your Company Name], including but not limited to services provided through mobile applications, websites, APIs, and third-party platforms (collectively referred to as "Services").
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Use of the Website
            </Typography>

            <Typography variant="body1" paragraph>
                Eligibility: You must be at least 13 years old to use this Website. By using the Website, you confirm that you meet this requirement. Users under 18 may only use the Services under the direction of a parent or guardian. The Services are not intended for users under the age of 13.
            </Typography>

            <Typography variant="body1" paragraph>
                License to Use: We grant you a limited, non-exclusive, non-transferable license to access and use the Website for personal, non-commercial purposes. You agree not to:
                Modify or copy any content.
                Use the Website for unlawful purposes.
                Disrupt the operation of the Website.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Content and Intellectual Property
            </Typography>
            <Typography variant="body1" paragraph>
                Ownership: All content, including text, images, graphics, logos, and software, is owned by or licensed to us and is protected under intellectual property laws.
            </Typography>

            <Typography variant="body1" paragraph>
                User Content: By submitting any content to the Website, you grant us a non-exclusive, royalty-free, worldwide license to use, reproduce, and distribute the content.            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Changes to the Terms of Service
            </Typography>

            <Typography variant="body1" paragraph>
                TextSimpler reserves the right to update these Terms of Service at any time. Notification of changes will be provided through email or website notices. Continued use of the Services after updates constitutes acceptance of the revised terms.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Services
            </Typography>

            <Typography variant="body1" paragraph>
                The Services are provided on a subscription basis and may include Free, Premium, and Team plans. Users must comply with any usage limits specified in their plan.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                License to Access the Services
            </Typography>

            <Typography variant="body1" paragraph>
                TextSimpler grants you a non-exclusive, non-transferable license to use the Services for personal or team use, subject to compliance with these Terms of Service.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                User Accounts
            </Typography>

            <Typography variant="body1" paragraph>
                Users are responsible for maintaining the confidentiality of their account credentials. Unauthorized account use is prohibited.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Prohibited Conduct
            </Typography>

            <Typography variant="body1" paragraph>
                Users may not engage in unauthorized access, content distribution, or activities that violate laws or the intellectual property rights of others while using the Services.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Termination
            </Typography>

            <Typography variant="body1" paragraph>
                TextSimpler reserves the right to terminate or suspend user access for violations of these Terms of Service or other policies.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Limitation of Liability
            </Typography>

            <Typography variant="body1" paragraph>
                The Services are provided "as is" without warranties of any kind. TextSimpler is not liable for any damages resulting from the use of the Services.
                To the fullest extent permitted by law, we shall not be liable for any damages, including but not limited to direct, indirect, incidental, or consequential damages, arising from your use of the Website.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Indemnification
            </Typography>

            <Typography variant="body1" paragraph>
                You agree to indemnify and hold harmless TextSimpler, its affiliates, and their respective officers, employees, and agents from any claims, liabilities, or expenses arising from your use of the Website or violation of these Te            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Ads and Third-Party Links
            </Typography>

            <Typography variant="body1" paragraph>
                Google AdSense: Our Website may display advertisements provided by Google AdSense. By using the Website, you agree to Google's advertising policies, which are available at Google Ads Policies.
                For more information, please visit
                <a href="https://support.google.com/adspolicy/" target="_blank" rel="noopener noreferrer">
                    Google Ads Policies
                </a>.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Governing Law
            </Typography>

            <Typography variant="body1" paragraph>
                These Terms of Service are governed by the laws of TextSimpler. Disputes will be resolved exclusively in the courts of [Your Jurisdiction].
            </Typography>

            <Typography variant="body1" paragraph>
                If you have any questions or concerns, please contact us..
            </Typography>

        </Container>
    );
}
